import React, { useState, useEffect } from 'react';
import { Tabs } from '../../../../app/components/Tabs'; 
import RegimesTributarios from './TaxRegime';
import Departamentos from './Department';
import Obligations from './Obligations';
import DocumentTemplates from './DocumentTemplates';
import { usePageTitle } from '../../../../contexts/PageTitleContext';


const Registrations = () => {
  const { setTitle } = usePageTitle();
          
  useEffect(() => {
    setTitle('Cadastros');
  }, [setTitle]);
  
  const sections = [
    {
      id: 'departamentos',
      title: 'Departamentos',
      count: '4',
      icon: (
        <div className="w-6 h-6 bg-blue-500 rounded-md flex items-center justify-center text-white">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
            />
          </svg>
        </div>
      ),
      content: <Departamentos />,
    },
    {
      id: 'regimes',
      title: 'Regimes Tributários',
      count: '34',
      icon: (
        <div className="w-6 h-6 bg-blue-500 rounded-md flex items-center justify-center text-white">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
      ),
      content: <RegimesTributarios />,
    },
    {
      id: 'obrigacoes',
      title: 'Obrigações',
      count: '1',
      icon: (
        <div className="w-6 h-6 bg-purple-500 rounded-md flex items-center justify-center text-white">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
            />
          </svg>
        </div>
      ),
      content: <Obligations />,
    },
    {
      id: 'templates',
      title: 'Templates de Documento',
      count: '4',
      icon: (
        <div className="w-6 h-6 bg-green-500 rounded-md flex items-center justify-center text-white">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
            />
          </svg>
        </div>
      ),
      content: <DocumentTemplates />,
    },
  ];

  const [activeTab, setActiveTab] = useState(sections[0].title);

  const tabsNames = sections.map((section) => section.title);

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const renderActiveContent = () => {
    const activeSection = sections.find(
      (section) => section.title === activeTab,
    );
    return activeSection ? activeSection.content : null;
  };

  return (
    <div>
      <div className="mx-auto container px-4">
        <div className="mb-6">
          <Tabs
            tabsName={tabsNames}
            activeTabName={activeTab}
            onTabClick={handleTabClick}
          />
        </div>

        {renderActiveContent()}

        {sections.find((section) => section.title === activeTab)?.count ===
          '0' && (
          <div className="flex flex-col items-center justify-center py-10">
            <svg
              className="h-16 w-16 text-gray-400 mb-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
              />
            </svg>
            <h3 className="text-lg font-medium text-gray-900">
              Nenhum item cadastrado
            </h3>
            <p className="text-sm text-gray-500 mt-1">
              Clique no botão + para adicionar
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Registrations;